import { Helmet } from 'react-helmet';
import PageHeader from './Common/PageHeader';
import './faq.css';
const Faqs = () => {
  const faqData = [
    {
      id: 1,
      question: 'Do you need an account for placing an order?',
      answer:
        'You can order without registering and complete your order as a guest. However, creating an account will help you in future transactions.',
    },
    {
      id: 2,
      question: 'I have forgotten my password',
      answer:
        'Click on "Forgot my password" and an email will be sent to you with the link to reset your password.',
    },
    {
      id: 3,
      question: 'Orders',
      answer: (
        <>
          <p className="faq-sub">How can I place an Order?</p>
          Add your products to the bag and proceed to checkout. Use your
          preferred payment method to complete the order. A confirmation email
          will be sent to confirm your order.
        </>
      ),
    },
    {
      id: 4,
      question: 'How to look for an item on the website?',
      answer:
        'Use the search box at the top of the page to quickly find any item you need.',
    },
    {
      id: 5,
      question: 'Can I reserve my Order online?',
      answer: 'Unfortunately, you cannot reserve your order online.',
    },
    {
      id: 6,
      question: 'Shipping & Handling',
      answer: (
        <>
          <p className="faq-sub">What is the delivery time?</p>
          Your order should be delivered within 5 to 7 working days.
          <p className="faq-sub mt-3">What are the delivery charges?</p>
          Charges vary depending on your city.
          <p className="faq-sub mt-3">What if I miss the delivery?</p>
          The courier company will contact you again for a second attempt, or
          you can reach out to us to arrange delivery.
        </>
      ),
    },
    {
      id: 7,
      question: 'Returns & Exchange',
      answer: (
        <>
          <p className="faq-sub">How to Return a Product?</p>
          Bakumia does not have a refund policy. We only offer exchanges.
          Refunds are only issued in exceptional cases (e.g., item out of
          stock).
          <p className="faq-sub mt-3">Canceling Your Order</p>
          You may cancel before processing begins. Once shipped and a tracking
          ID is issued, the order cannot be canceled. After delivery, you can
          return or exchange according to our policy.
        </>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions | Bakumia</title>
        <meta
          name="keywords"
          content="creative items,unique items,creative craft items,creative gift items,creative home decor,unique kitchenware,home accessories"
        />
        <meta
          name="description"
          content="Find answers to the most common questions about shopping at Bakumia. Our team is here to help you enjoy a smooth and happy shopping experience."
        />
      </Helmet>

      <PageHeader title="FAQs" />

      <section className="faq-section">
        <div className="container-fluid">
          <div className="text-center mb-5">
            <h2 className="display-6 fw-medium">FAQs</h2>
            <hr className="faq-divider" />
          </div>

          <div className="accordion" id="faqAccordion">
            {faqData.map((item) => (
              <div className="accordion-item" key={item.id}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#faq${item.id}`}
                    aria-expanded="false"
                    aria-controls={`faq${item.id}`}
                  >
                    <span
                      style={{
                        maxWidth: window.innerWidth > 576 ? '100%' : '300px',
                      }}
                      className="text-truncate d-inline-block"
                    >
                      {item.question}
                    </span>
                  </button>
                </h2>
                <div
                  id={`faq${item.id}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">{item.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Faqs;
